import { ClassesBuilder } from '@utilities';

const classesConfig = {
  container: `h-full rounded-lg shadow-lg group bg-white transition overflow-hidden w-full snap-center border-2 border-transparent hover:border-click-orange p-8 mb-10`,
  heading: `text-3xl`,
};

export default new ClassesBuilder(classesConfig);
